module.exports = __webpack_public_path__ + "img/devices_2_1920.04b0496.jpg";